import { graphql, useFragment } from 'react-relay';

import { DeliveryOrderDifferenceItemList_difference$key } from '../../../relay/__generated__/DeliveryOrderDifferenceItemList_difference.graphql';
import { isNullable } from '../../../utils/is';
import EmptyState from '../../core/EmptyState';
import ItemList from '../../core/ItemList';
import Text from '../../core/Text';
import View from '../../core/View';
import DiffItem from '../../difference/DiffItem';

const DeliveryOrderDifferenceItemList_difference = graphql`
  fragment DeliveryOrderDifferenceItemList_difference on Difference {
    ... on DeliveryOrderDifference {
      description {
        ...DiffItem_diff
      }
      address {
        ...DiffItem_diff
      }
      addressDetail {
        ...DiffItem_diff
      }
      zipCode {
        ...DiffItem_diff
      }
      recipientName {
        ...DiffItem_diff
      }
      recipientNumber {
        ...DiffItem_diff
      }
      stuffTitle {
        ...DiffItem_diff
      }
      title {
        ...DiffItem_diff
      }
    }
  }
`;

type Props = {
  difference: DeliveryOrderDifferenceItemList_difference$key;
};

const DeliveryOrderDifferenceItemList = ({ difference }: Props) => {
  const { description, address, addressDetail, zipCode, recipientName, recipientNumber, stuffTitle, title } =
    useFragment(DeliveryOrderDifferenceItemList_difference, difference);

  const diffItems = [
    {
      title: '제목',
      diff: title,
    },
    {
      title: '설명',
      diff: description,
    },
    {
      title: '우편번호',
      diff: zipCode,
    },
    {
      title: '주소',
      diff: address,
    },
    {
      title: '상세 주소',
      diff: addressDetail,
    },
    {
      title: '물품',
      diff: stuffTitle,
    },
    {
      title: '수령자',
      diff: recipientName,
    },
    {
      title: '수령자 전화번호',
      diff: recipientNumber,
    },
  ].filter(({ diff }) => !isNullable(diff));

  return (
    <ItemList
      items={diffItems}
      renderItem={({ title, diff }) => (
        <>
          <Text sx={{ fontSize: 1, fontWeight: 'bold' }}>{title}</Text>
          <View sx={{ marginTop: 2 }}>
            <DiffItem diff={diff!} />
          </View>
        </>
      )}
      renderItemWrapper={(children, { title }, i) => (
        <View key={title} sx={{ marginTop: i > 0 ? 3 : 0 }}>
          {children}
        </View>
      )}
      emptyState={
        <View sx={{ paddingY: 6 }}>
          <EmptyState
            title={'기록되지 않은 히스토리이에요'}
            description={'이 기능이 만들어지기 전에 일어난 일이거나 오류로 누락된 히스토리입니다.'}
          />
        </View>
      }
    />
  );
};

export default DeliveryOrderDifferenceItemList;
